export default {
  title: 'React TypeScript Ant Design Boilerplate',
  contentFooter: `Ⓒ Copyright TotallyAwesome Ltd. 2023 ${
    process.env.REACT_APP_ENV === 'development' ? '(v.1.1.3)' : '(v.1.1.1)'
  }`
};
